module.exports = __webpack_public_path__ + "static/media/icon.c146f79a.png";